import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { routesWithoutWhitelabelGroupCheck, userWhitelabelGroupCookieName } from '@/utils/constants'
import { logoutRoutine, authGetters } from '@/store/modules/auth/routines'
import { getCookie, getWhitelabelGroup, setUTMCookiesFromURL, legacyFormRedirect } from '@/utils/utils'

Vue.use(Router)

// Add routes dynamically in features.
const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve({
            selector: to.hash,
            offset: { x: 0, y: 95 }
          })
        }, 500)
      })
    }
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: []
})

router.beforeEach(function (to, from, next) {
  /**
   * Lock a logged-in user to their own whitelabel: if an authenticated user's group
   * differs from the current subdomain, log them out and redirect to theirs. The auth
   * check is deliberate; anonymous visitors must be able to browse any whitelabel.
   */
  const userWhitelabelGroup = getCookie(userWhitelabelGroupCookieName)
  const currentWhitelabelGroup = getWhitelabelGroup()
  if (
    !routesWithoutWhitelabelGroupCheck.includes(to.name) &&
    store.getters[authGetters.IS_AUTHENTICATED] &&
    userWhitelabelGroup &&
    currentWhitelabelGroup !== userWhitelabelGroup
  ) {
    store.commit(logoutRoutine.TRIGGER)
    store.dispatch(logoutRoutine.SUCCESS)

    const hostnameToChange = window.location.hostname.split('.').shift()
    const newUrl = window.location.href.replace(hostnameToChange, userWhitelabelGroup === 'swoop' ? 'app' : userWhitelabelGroup)

    return window.location.assign(newUrl)
  }

  if (store.getters.USER?.isXeroRestrictedUser && !checkXeroMarketplaceClientsAccess(to)) {
    return next({ name: 'integrations' })
  }

  // Main.
  const { meta, path } = to

  if (meta?.permissions) {
    const { roles, permissions, redirectTo } = meta.permissions
    const destination = typeof redirectTo === 'string' ? { path: redirectTo } : redirectTo

    router.app.$authorize
      .isAuthorized(roles, permissions)
      .then(() => {
        next()
      })
      .catch(() =>
        next({
          ...destination,
          query: {
            redirectTo: path
          }
        })
      )
  } else {
    next()
  }
})

router.beforeResolve(function (to, from, next) {
  if (!to.matched.length) {
    return handleRedirect(to, from, next)
  }
  return next()
})

/*
 * Allow the user access to certain pages if they came from xero marketplace
 */
function checkXeroMarketplaceClientsAccess(to) {
  return [
    'profile',
    'data-room',
    'login',
    'forgot-password',
    'forgot-password-check-email',
    'integrations',
    'apideck',
    'bank-integration-callback',
    'bank-integration',
    'apideckCallback',
    'truelayer-callback',
    'cashflow-forecast-integration',
    'cashflow-forecast',
    'cashflow-forecasting-integration'
  ].includes(to.name)
}

function handleRedirect(to, from, next) {
  setUTMCookiesFromURL()

  let goal = null
  if (to.path.includes('goal/')) {
    goal = to.path.split('/').pop()
  }

  return next(legacyFormRedirect(goal))
}

export default router
